import React, { JSX, useMemo } from 'react'
import { classNames } from '@hermes/design-system'
import { container, fillRating, fillEndorsement, fillEndorsementWithoutRating } from './ratingBar.css'

export type RatingBarProps = {
  className?: string
  currentRating: number
  currentEndorsement: number
  onClick?: () => void
}

const RatingBar = ({ className, currentRating, currentEndorsement, onClick }: RatingBarProps): JSX.Element => {
  const widthOfRating = useMemo(() => {
    if (currentRating >= 85) {
      return '85%'
    }
    if (currentRating <= 10) {
      return '10%'
    }
    return `${Math.ceil((currentRating / 100) * 100)}%`
  }, [currentRating])

  const widthOfEndorsement = useMemo(() => {
    if (!currentRating) {
      if (currentEndorsement >= 85) {
        return '85%'
      }
      if (currentEndorsement <= 10) {
        return '10%'
      }
      return `${Math.ceil((currentEndorsement / 100) * 100)}%`
    }
    if (currentRating >= 85) {
      return '100%'
    }
    if (currentRating <= 10) {
      return '20%'
    }
    return `${Math.ceil((currentRating / 100) * 100) + 15}%`
  }, [currentEndorsement, currentRating])

  return (
    <div className={classNames(className, container)} onClick={onClick}>
      {currentRating ? (
        <div style={{ width: widthOfRating }} className={fillRating} >
          {currentRating}
        </div>
      ) : null}
      {currentEndorsement ? (
        <div style={{ width: widthOfEndorsement }} className={classNames({
          [fillEndorsement]: currentRating,
          [fillEndorsementWithoutRating]: !currentRating
        })} >
          {currentEndorsement}
        </div>
      ) : null}
    </div>
  )
}

export default RatingBar
